import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpBackend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

// Ensure vite env typing is available for import.meta.env
// This is safe in Vite projects; it won't affect runtime.
/// <reference types="vite/client" />

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    supportedLngs: ["en", "tr", "fr", "ar", "ru"],
    debug: false,
    interpolation: {
      escapeValue: false, // React already safes from xss
    },
    backend: {
      loadPath: "/locales/{{lng}}/translation.json",
    },
    detection: {
      order: ["querystring", "localStorage", "navigator", "htmlTag"],
      lookupQuerystring: "lang",
      caches: ["localStorage"],
    },
    react: {
      useSuspense: false,
    },
    saveMissing: false,
    // Align handler signatures with i18next typings
    missingKeyHandler: (
      _lngs: readonly string[],
      _ns: string,
      _key: string,
      _fallbackValue: string,
      _updateMissing: boolean,
      _options: any
    ) => {
      // Silence missing translation logs to avoid leaking internals
    },
    parseMissingKeyHandler: (missingKey: string) => {
      return missingKey;
    },
    returnEmptyString: false,
    returnNull: false,
    returnObjects: false,
    keySeparator: ".",
    nsSeparator: ":",
    pluralSeparator: "_",
    contextSeparator: "_",
  });

export default i18n;
